/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const MedicalDetailsIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 29 34"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="24.6666667" cy="14" r="2.66666667" />
      <path d="M3.33333333,2.66666667 C1.86133333,2.66666667 0.666666667,3.86133333 0.666666667,5.33333333 L0.666666667,12 C0.666666667,15.6826667 3.65066667,18.6666667 7.33333333,18.6666667 C11.016,18.6666667 14,15.6826667 14,12 L14,5.33333333 C14,3.86133333 12.8053333,2.66666667 11.3333333,2.66666667" />
      <path d="M7.33333333,18.6666667 L7.33333333,28.6666667 C7.33333333,30.1386667 8.528,31.3333333 10,31.3333333 C11.4733333,31.3333333 12.6666667,30.1386667 12.6666667,28.6666667 L12.6666667,22 C12.6666667,20.1586667 14.1586667,18.6666667 16,18.6666667 C17.84,18.6666667 19.3333333,20.1586667 19.3333333,22.0013333 L19.3333333,26 C19.3333333,27.472 20.528,28.6666667 22,28.6666667 C23.4733333,28.6666667 24.6666667,27.472 24.6666667,26 L24.6666667,16.6666667" />
      <path d="M5.33333333,2.66666667 C5.33333333,4.66666667 3.33333333,4.66666667 3.33333333,4.66666667 L3.33333333,0.666666667 C3.33333333,0.666666667 5.33333333,0.666666667 5.33333333,2.66666667 Z" />
      <path d="M9.33333333,2.66666667 C9.33333333,0.666666667 11.3333333,0.666666667 11.3333333,0.666666667 L11.3333333,4.66666667 C11.3333333,4.66666667 9.33333333,4.66666667 9.33333333,2.66666667 Z" />
    </g>
  </svg>
);

export default MedicalDetailsIcon;
